import WidgetMetricDisplay from "@/components/common/WidgetMetricDisplay";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import React from "react";
import { PhoneOff } from "lucide-react";

interface AbandonedCallsWidgetProps {
  data: { value: number; comparisonPercentage?: number };
  icon?: React.ReactNode;
  loading?: boolean;
  error?: string;
  onClick?: (filters: { [key: string]: string[] }) => void;
}

const AbandonedCallsWidget: React.FC<AbandonedCallsWidgetProps> = ({ data, loading, onClick }) => {
  const canClick = onClick && data.value > 0;
  
  const handleClick = () => {
    if (canClick) {
      onClick({ callStatus: ["Abandoned"] });
    }
  };

  return (
    <div 
      className={`w-full min-w-[200px] rounded-lg border flex flex-col bg-white dark:bg-[#0C3451] dark:text-white dark:border-[#0C3451] p-3 hover:bg-gray-50 dark:hover:bg-[#1a4a66] transition-colors ${canClick ? 'cursor-pointer' : ''}`}
      onClick={handleClick}
    >
    <div className="flex flex-row items-center justify-between">
      <div className="text-[14x] font-[500] text-primary dark:text-white truncate">Total Abandoned Calls</div>
      <TooltipProvider>
        <Tooltip delayDuration={0}>
          <TooltipTrigger asChild>
            <span className="cursor-pointer">
              <PhoneOff className="h-4 w-4 text-primary dark:text-white" />
            </span>
          </TooltipTrigger>
          <TooltipContent side="top">
            <p className="max-w-xs text-xs">
              The total number of incoming calls that were disconnected by the caller while in the IVR without any agents being hunted within the given time.
            </p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
    <div>
      <WidgetMetricDisplay
        value={data.value}
        comparisonPercentage={data.comparisonPercentage}
        loading={loading}
        invertColors={true}
      />
    </div>
  </div>
  );
};

export default AbandonedCallsWidget; 